import { render } from "./RegForm.vue?vue&type=template&id=4c26e34c&scoped=true"
import script from "./RegForm.vue?vue&type=script&lang=js"
export * from "./RegForm.vue?vue&type=script&lang=js"

import "./RegForm.vue?vue&type=style&index=0&id=4c26e34c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c26e34c"]])

export default __exports__